export default "__VITE_ASSET__B83vPgQW__"